import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { bolehKelolaSinkronStase } from "@/lib/roles";
import { keteranganIkutRotasi } from "@/lib/sinkronStase";

// Di bawah isian Stase pada dialog Edit Peserta: keterangan saat saklar Sinkronisasi Stase hidup, dan pengalih kunci
// utk Super Admin/Admin UFP (disimpan langsung lewat PUT /peserta/{id}/kunci-stase, terpisah dari "Simpan Perubahan").
export default function KunciStaseRotasi({ pesertaId, terkunciAwal, role, stase, status }) {
    const [saklarAktif, setSaklarAktif] = useState(false);
    const [terkunci, setTerkunci] = useState(!!terkunciAwal);
    const [sibuk, setSibuk] = useState(false);
    const sedangSimpan = useRef(false);
    const bolehKunci = bolehKelolaSinkronStase(role);

    useEffect(() => { setTerkunci(!!terkunciAwal); }, [pesertaId, terkunciAwal]);
    useEffect(() => {
        let aktif = true;
        api.get("/sinkron-stase/status")
            .then(({ data }) => { if (aktif) setSaklarAktif(!!data?.aktif); })
            .catch(() => { if (aktif) setSaklarAktif(false); });
        return () => { aktif = false; };
    }, []);

    const ubah = async (kunci) => {
        if (sedangSimpan.current) return;
        sedangSimpan.current = true;
        setSibuk(true);
        try {
            const { data } = await api.put(`/peserta/${pesertaId}/kunci-stase`, { kunci });
            setTerkunci(!!data.stase_otomatis_nonaktif);
            toast.success(data.stase_otomatis_nonaktif ? "Stase dikunci" : "Kunci Stase dibuka");
        } catch (e) {
            toast.error(formatApiErrorDetail(e.response?.data?.detail));
        } finally {
            sedangSimpan.current = false;
            setSibuk(false);
        }
    };

    const keterangan = keteranganIkutRotasi({ saklarAktif, terkunci, stase, status });
    return (
        <>
            {keterangan && <p className="text-[11px] text-slate-500 mt-1" data-testid="stase-ikut-rotasi">{keterangan}</p>}
            {bolehKunci && (
                <label className="flex items-center gap-2 mt-2 text-xs text-slate-700">
                    <Switch checked={terkunci} disabled={sibuk} onCheckedChange={ubah} data-testid="kunci-stase"
                        aria-label="Kunci Stase (jangan ikuti Rotasi)" />
                    Kunci Stase (jangan ikuti Rotasi)
                </label>
            )}
        </>
    );
}
